var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFavouriteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2729_20262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8643 3.22858C12.4789 2.56443 11.5198 2.56443 11.1344 3.22858L8.42034 7.90589C8.22997 8.23398 7.90092 8.45787 7.52585 8.51451L2.43954 9.28274C1.58526 9.41177 1.2856 10.4904 1.9509 11.0416L5.74 14.1808C6.09074 14.4714 6.25566 14.9298 6.17045 15.3772L5.17929 20.5823C5.0226 21.4052 5.88639 22.0445 6.62754 21.6542L11.4169 19.1324C11.7815 18.9405 12.2172 18.9405 12.5817 19.1324L17.3711 21.6542C18.1123 22.0445 18.9761 21.4052 18.8194 20.5823L17.8282 15.3772C17.743 14.9298 17.9079 14.4714 18.2587 14.1808L22.0477 11.0416C22.7131 10.4904 22.4134 9.41177 21.5591 9.28274L16.4728 8.51452C16.0977 8.45787 15.7687 8.23398 15.5783 7.90589L12.8643 3.22858Z",
    fill: "#FFBE81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2729_20262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFavouriteIcon);
export default __webpack_public_path__ + "static/media/ActiveFavouriteIcon.9bb6deb1c0dac823a4fb0dff801af263.svg";
export { ForwardRef as ReactComponent };